module.exports = __webpack_public_path__ + "img/type_3.b68c1b61.png";